import { useLayoutEffect, type RefObject } from 'react';

/**
 * Toggles a bare `data-<name>` attribute for a CSS transition to key on. The element mounts without it,
 * so its unmarked styles are what an enter transition starts from.
 */
export const useTransitionMark = (ref: RefObject<HTMLElement | null>, name: string, marked: boolean) => {
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    if (!marked) {
      delete element.dataset[name];
      return;
    }
    // The unmarked styles have to be computed before the mark lands, or there is nothing to transition from.
    element.getBoundingClientRect();
    element.dataset[name] = '';
  }, [ref, name, marked]);
};
